export default __webpack_public_path__ + "static/media/PortfolioProject1.2acdc4b1.png";